import React from "react";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { addpresent } from "../FewCommonMethods";
import { Commas } from "../AllDateTimeReleventFormate";
import { Tooltip } from "react-tooltip";
import DeadlineComponents from "../DeadlineComponents";
import { penaltytips } from "../Tooltips/tooltip";
import { decodeHtml } from "../../../assests/extention/commonfunction";

export default function CustomeMilestone({ milestones, title = 'Milestones' }) {

  return (
    <>
      {Array.isArray(milestones) && milestones?.length > 0 && (
        <div className="lang-sec">
          <h6>{title}</h6>
          <div className="table-responsive">
            <table className="table ">
              <thead>
                <th>Milestones</th>
                <th>Deadline</th>
                <th>Amount</th>
                <th>
                  Penalty &nbsp;
                  <img
                    data-tooltip-id="my-tooltip-1"
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/penalty.svg`}
                    alt=""
                  />
                </th>
              </thead>
              <tbody>
                {Array.isArray(milestones) &&
                  milestones.map((item, index) => (
                    <tr>
                      <td>
                        {index + 1}. {decodeHtml(item.title)}
                      </td>
                      <td>
                        {/* {item.duration ? item.duration : "-----"} &nbsp; */}
                        {/* {item?.duration_type == 2
                          ? "Days"
                          : item?.duration_type == 3
                            ? "Weeks"
                            : item?.duration_type == 4
                              ? "Months"
                              : ""} */}
                        <DeadlineComponents milestones={true}  posts={item} />
                      </td>
                      <td>
                        {item.amount ? "$ " : ""}
                        {item.amount ? Commas(item.amount) : "-----"}
                      </td>
                      <td>
                        {item.penalty ? addpresent(item.penalty) : "-----"}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <Tooltip
        id="my-tooltip-1"
        place="bottom"
        content={penaltytips}
      />
    </>
  );
}
